import styled from 'styled-components';
import { Typography } from '@web-chat-core/ui-kit';

export const Block = styled.div`
    padding-top: 6px;
    padding-bottom: 6px;
`;

export const Title = styled(Typography)`
    margin-bottom: 8px;
`;

export const Separator = styled.div`
    height: 1px;
    width: 100%;
    background: ${(props) => props.theme.root.colors.basicColors['10%']};
    margin-top: 16px;
    margin-bottom: 16px;
`;
